import WealthJourneyLineChart from './v3/WealthJouneyLineChart'
import WealthJourneyProvider from './v3/WealthJourneyProvider'

const WealthJourneyModule = {
  WJ_LineChart: WealthJourneyLineChart,
  WealthJourneyProvider: WealthJourneyProvider
}

export default WealthJourneyModule
